import { MAILBOX_CONNECTION_STATUS } from '../constants';

export const getEffectiveMailboxConnectionStatus = ({
  mailboxConnectionId,
  mailboxConnectionStatus,
}: {
  mailboxConnectionId?: number | null;
  mailboxConnectionStatus?: string | null;
}) => {
  if (!mailboxConnectionId) {
    return null;
  }

  return mailboxConnectionStatus || MAILBOX_CONNECTION_STATUS.ACTIVE;
};
